import React from 'react';
import { useStores } from 'hooks';
import { observer } from 'mobx-react-lite';
import { Container } from './Styles';
import { getStreamerHost } from '../../../endpoints';
import { SplitButton } from './SplitButton';
import { useHistory } from 'react-router-dom';

export const LaunchPad = observer(() => {
  const {
    AuctionStore: { layoutSettings },
  } = useStores();
  const history = useHistory();

  const screens = layoutSettings;

  const handleClick = (route, layout, sameWindow) => {
    if (sameWindow) {
      history.push(`/${route}`);
      return;
    }
    window.open(`/${route}`, layout, '');
  };

  return (
    <Container>
      {screens
        ?.filter((item) => item.layoutType !== 'Bidder')
        .map((item) => (
          // <Link
          //   data-testid={`btn-${item.layout}`}
          //   key={item.layoutID}
          //   target="_blank"
          //   onClick={(e) => {
          //     e.preventDefault();
          //     handleClick(item.slug, item.layout);
          //   }}
          // >
          //   {item.layout?.replace(' Vehicle ', ' ')}
          // </Link>
          <SplitButton
            data-testid={`btn-${item.layout}`}
            key={item.layoutID}
            text={item.layout?.replace('NPA Vehicle ', '')}
            onClick={(e, sameWindow) => {
              e.preventDefault();
              handleClick(item.slug, item.layout, sameWindow);
            }}
          />
        ))}
      {/* <Link
        data-testid="btn-streamer"
        key={10}
        onClick={(e) => {
          e.preventDefault();
          window.open(getStreamerHost(), 'streamerWindow', '');
        }}
        target="_blank"
      >
        Audio Streamer
      </Link> */}
      <SplitButton
        text="Audio Streamer"
        data-testid="btn-streamer"
        key={10}
        onClick={(e) => {
          e.preventDefault();
          window.open(getStreamerHost(), 'streamerWindow', '');
        }}
      />
    </Container>
  );
});

export default LaunchPad;
